module.exports = __webpack_public_path__ + "static/media/claim.7615c438.png";